export const visit = (vm, at) => {
vm(require("foundations-components/lang/ko.lyaml"));
at({ "ko": { "placeholder": "\uC790\uB9AC \uD45C\uC2DC\uC790" } });
};